var $da1e751a92575e02$exports = {};
$da1e751a92575e02$exports = {
  "ascending": "nouseva",
  "ascendingSort": function ascendingSort(args) {
    return "lajiteltu sarakkeen ".concat(args.columnName, " mukaan nousevassa j\xE4rjestyksess\xE4");
  },
  "columnSize": function columnSize(args) {
    return "".concat(args.value, " pikseli\xE4");
  },
  "descending": "laskeva",
  "descendingSort": function descendingSort(args) {
    return "lajiteltu sarakkeen ".concat(args.columnName, " mukaan laskevassa j\xE4rjestyksess\xE4");
  },
  "resizerDescription": "Aloita koon muutos painamalla Enter-n\xE4pp\xE4int\xE4",
  "select": "Valitse",
  "selectAll": "Valitse kaikki",
  "sortable": "lajiteltava sarake"
};
export { $da1e751a92575e02$exports as default };